export default API => ({
  /******任务接口优化 */
  // 列表初始化
  findTaskList({ data, params }) {
    return API({ //学习列表
        url:'/task/v1/client/findTaskList',
        params,
        data
    });
  },
  // 列表二次渲染
  findTaskLearningInfo({ data, params }) {
    return API({ //学习列表
        url:'/task/v1/client/findTaskLearningInfo',
        params,
        data
    });
  },
  // 详情页初始化
  taskDetailWithoutLogin({ data, params }) {
    return API({ //学习列表
        url:'/task/v1/client/taskDetailWithoutLogin',
        params,
        data
    });
  },
  // 详情页二次渲染
  taskDetailExt({ data, params }) {
    return API({ //学习列表
        url:'/task/v1/client/taskDetailExt',
        params,
        data
    });
  },
    trainList({ data, params }) {
        return API({ //学习列表
            url:'task/v1/client/taskList',
            params,
            data
        });
    },
    taskDetail({ data, params }) {
        return API({ //任务详情接口
            url:'task/v1/client/taskDetail',
            params,
            data
        });
    },
    // 快速学习课程
    quicklyStudy(taskId,taskType){
        return API({ 
            url:`/course/v1/open/courseItem/quickLearn?taskId=${taskId}&taskType=${taskType}`
        });
    },



    
    evaluationAssess({data, params}) {
        return API({ url: '/assess/v1/open/assess/myAssess', method:'post', params, data });
    },
    findTaskRule({params}) {
        return API({ //简介
            url: '/task/v1/taskRule/findTaskRule',
            params,
        });
    },
    // 我的考试列表
    findUserExams({params}) {
        return API({
            url: '/exam/v1/userExam/findUserExams',
            params,
        })
    },

    //培训任务线下实训预约列表
    // 获取用户指定培训任务可选择线下实训列表及预约状态
    getUserTaskTrainingList(params) {
        return API({
            url: '/task/v1/client/getUserTaskTrainingList',
            params,
        })
    },

    // 判断用户指定培训任务是否已经预约线下实训项目

    isUserTaskTrainingReserved(params) {
        return API({
            url: '/task/v1/client/isUserTaskTrainingReserved',
            params,
        })
    },
    

    // 重新预约新的线下实训项目并取消旧的预约
    replaceTaskTraining(params) {
        return API({
            url: '/task/v1/client/replaceTaskTraining',
            params,
            method: 'POST'

        })
    },
    //  预约指定线下实训项目
    reserveTaskTraining(params) {
        return API({
            url: '/task/v1/client/reserveTaskTraining',
            params,
            method: 'POST'
        })
    },
    
    // 取消预约指定线下实训项目
    cancelTaskTraining(params) {
        return API({
            url: '/task/v1/client/cancelTaskTraining',
            params,
            method: 'POST'

        })
    },
    // 扫码签到和扫码签退
    courseSign({params,data}) {
        return API({
            url: '/offlineTrain/v1/trainingAttendanceRecord/courseSign',
            params,
            data,
            method: 'post'

        })
    },
    // 河南交通电子签名保存参数：  taskId 任务ID，url  签名地址
    saveTaskUserSignature(data) {
        return API({
            url: '/task/v1/task/signature/saveTaskUserSignature',
            data,
            method: 'post'

        })
    },
    // 查看是否有签名 参数：  taskId 任务ID   
    viewUserSignature(params) {
        return API({
            url: '/task/v1/task/signature/viewUserSignature',
            params,
        })
    },

    // 培训任务人脸识别规则
    // 保存人脸识别访问记录
    // 说明：type 是必填项，
    // 如果type=1,  传参：taskId,其它不传；
    // 如果 type=2  传参：taskId,courseId  其它不传；
    // 如果 type=3  参数都需要传
    saveFaceAccess(data) {
        return API({
            url: '/saas/v1/faceAccess/saveFaceAccess',
            data,
            method: 'post'

        })
    },
    //  查看是否已保存人脸识别访问记录
    // 说明：type 是必填项，
    // 如果type=1,  传参：taskId,其它不传；
    // 如果 type=2  传参：taskId,courseId  其它不传；
    // 如果 type=3  参数都需要传
    // {
    //     "taskId": "任务id",
    //     "courseId": "课程id",
    //     "resId": "素材id",
    //     "type": "类型，1任务 2课程  3素材",
    // }
    viewFaceAccess(data) {
        return API({
            url: '/saas/v1/faceAccess/viewFaceAccess',
            data,
            method: 'post'

        })
    },
})

